"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultBehaviorCodeReactionCreateDto = void 0;
const class_validator_1 = require("class-validator");
const mappable_base_1 = require("../../mappable.base");
const class_transformer_1 = require("class-transformer");
const boolean_transform_1 = require("../../constants/boolean.transform");
const enums_1 = require("../../enums");
class DefaultBehaviorCodeReactionCreateDto extends mappable_base_1.MappableBase {
    constructor(behaviorCodeReactionOptions) {
        super();
        if (!behaviorCodeReactionOptions)
            return;
        this.printCopies = behaviorCodeReactionOptions.printCopies;
        this.points = behaviorCodeReactionOptions.points;
        this.reactionMultiplier = behaviorCodeReactionOptions.reactionMultiplier;
        this.reactionId = behaviorCodeReactionOptions.reactionId;
        this.active = behaviorCodeReactionOptions.active;
        this.reactionType = behaviorCodeReactionOptions.reactionType;
    }
    getFields() {
        return [
            'triggerCount',
            'printCopies',
            'points',
            'reactionMultiplier',
            'reactionId',
            'schoolId',
            'active',
            'reactionType',
        ];
    }
    printCopies = 1;
    points = 0;
    reactionMultiplier = 1;
    reactionId;
    active;
    reactionType;
}
exports.DefaultBehaviorCodeReactionCreateDto = DefaultBehaviorCodeReactionCreateDto;
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Object)
], DefaultBehaviorCodeReactionCreateDto.prototype, "printCopies", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Object)
], DefaultBehaviorCodeReactionCreateDto.prototype, "points", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Object)
], DefaultBehaviorCodeReactionCreateDto.prototype, "reactionMultiplier", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], DefaultBehaviorCodeReactionCreateDto.prototype, "reactionId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(boolean_transform_1.BooleanStringTransform),
    __metadata("design:type", Boolean)
], DefaultBehaviorCodeReactionCreateDto.prototype, "active", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(enums_1.ReactionTypeEnum),
    __metadata("design:type", String)
], DefaultBehaviorCodeReactionCreateDto.prototype, "reactionType", void 0);
